export function userId(state) {
    return state.user_id;
}

export function userAccess(state) {
    return parseInt(state.user_access);
}

export function isDev(state) {
    return state.is_dev;
}

export function prefixMqtt(state) {
    return state.prefix_mqtt;
}



export const can = (state) => (permission, method) => {

    if (state.is_dev) return true;
    if (state.permissions.hasOwnProperty(permission) && state.permissions[permission][method]) return true;
    return false;
}


